import React from 'react';
import { Header, HeaderProps } from '@stitch-fix/knit';

export interface KnitHeaderWrapperProps {
  path: string;
  region: HeaderProps['region'];
}

const KnitHeaderWrapper = ({ path, region }: KnitHeaderWrapperProps) => (
  <Header activePage={path} region={region} />
);

export default KnitHeaderWrapper;
